<form method="dialog" *ngIf="dialog">
    <button class="btn-close float-end"></button>
</form>

<div id="multimedia" class="m-3">
    
    <h2>Multimedia de la lección</h2>

    <div id="multimedia-loading" class="mt-3" *ngIf="loading">
        <i class="fa fa-spinner fa-spin"></i>
        <span>Cargando...</span>
    </div>

    <div id="multimedia-empty" class="mt-3" *ngIf="!loading && !hasMultimedia">
        <p>No hay multimedia en esta lección.</p>
    </div>

    <div id="multimedia-size" class="mt-3" *ngIf="!loading && hasMultimedia">
        <p>Tamaño total de multimedia: {{ multimediaTotalSize }} MB</p>
    </div>

    <div id="multimedia-toggle" class="mt-3" *ngIf="!loading">
        <button class="btn btn-primary" *ngIf="!upload" (click)="upload = true; download = false;">
            <i class="fa fa-photo-video"></i>
            <i class="fa fa-upload"></i>
            <span>Subir multimedia</span>
        </button>
        <button class="btn btn-primary" *ngIf="upload" (click)="upload = false; download = false; getLessonMultimedia(lessonID);">
            <i class="fa fa-photo-video"></i>
            <i class="fa fa-eye"></i>
            <span>Ver multimedia existente</span>
        </button>
    </div>

    <div id="multimedia-upload" class="mt-3" *ngIf="upload">
        <p class="fw-bold">Subir multimedia</p>
        <input multiple type="file" name="files[]" accept="image/*, video/*" class="btn btn-primary" (change)="addFileToList($event)">
        <p>Tamaño máximo de archivo: 32 MB</p>

        <div id="multimedia-lists-container" class="row mx-1">
            <div id="images-list-container" *ngIf="uploadImages.length > 0">
                <label for="images-list">
                    <p class="fw-bold">Imágenes en cola:</p>
                    <ul id="images-list">
                        <li *ngFor="let image of uploadImages; let i = index;">
                            <span>{{ image.name }} ({{ image.sizeMB }} MB)</span>
                            <button class="multimedia-remove" (click)="removeFileFromList(image)">
                                <i class="fa fa-minus"></i>
                            </button>
                        </li>
                    </ul>
                </label>
            </div>
        
            <div id="videos-list-container" *ngIf="uploadVideos.length > 0">
                <label for="videos-list">
                    <p class="fw-bold">Vídeos en cola:</p>
                    <ul id="videos-list">
                        <li *ngFor="let video of uploadVideos; let v = index;">
                            <span>{{ video.name }} ({{ video.sizeMB }} MB)</span>
                            <button class="multimedia-remove" (click)="removeFileFromList(video)">
                                <i class="fa fa-minus"></i>
                            </button>
                        </li>
                    </ul>
                </label>
            </div>
        </div>

        <div id="multimedia-upload-result" class="form-group text-center">
            <div id="multimedia-uploading" *ngIf="uploading">
                <i class="fa fa-spinner fa-spin"></i>
                <span>Subiendo multimedia, espere, por favor...</span>
            </div>
            <div id="multimedia-upload-error" class="text-danger" *ngIf="uploadError">
                <i class="fa fa-times"></i>
                <span>Hubo un error, no se ha subido la multimedia. Por favor, inténtelo de nuevo con otros archivos.</span>
            </div>
            <div id="multimedia-upload-success" class="text-success" *ngIf="uploadSuccess">
                <i class="fa fa-check"></i>
                <span>Se han subido los archivos seleccionados y se han asignado a la lección actual.</span>
            </div>
        </div>

        <button class="btn btn-success"
            [attr.disabled]="uploading || (uploadImages.length === 0 && uploadVideos.length === 0) ? 'disabled' : null"
            (click)="uploadMultimediaFiles()">
            <i class="fa fa-photo-video"></i>
            <i class="fa fa-upload"></i>
            <span>Subir multimedia</span>
        </button>

    </div>

    <div id="multimedia-download-btn" class="mt-3" *ngIf="hasMultimedia && !loading && !upload">
        <button class="btn btn-primary" *ngIf="!download" (click)="download = true">
            <i class="fa fa-photo-video"></i>
            <i class="fa fa-download"></i>
            <span>Descargar multimedia</span>
        </button>
    </div>

    <div id="multimedia-download-options" class="mt-3" *ngIf="download">
        <button class="btn btn-primary me-3" (click)="downloadMultimedia(courseID, lessonID, 'all')">
            <i class="fa fa-photo-video"></i>
            <i class="fa fa-download"></i>
            <span>Descargar todo</span>
        </button>
        <button class="btn btn-primary me-3" (click)="downloadMultimedia(courseID, lessonID, 'image')">
            <i class="fa fa-images"></i>
            <i class="fa fa-download"></i>
            <span>Descargar sólo imágenes</span>
        </button>
        <button class="btn btn-primary me-3" (click)="downloadMultimedia(courseID, lessonID, 'video')">
            <i class="fa fa-video"></i>
            <i class="fa fa-download"></i>
            <span>Descargar sólo vídeos</span>
        </button>
        <button class="btn btn-danger me-3" (click)="download = false">
            <i class="fa fa-times me-0"></i>
        </button>
    </div>
    
    <div id="heading-multimedia-images" class="mt-3" *ngIf="!upload && images.length > 0">
        <hr>
        <p class="fw-bold">
            <i class="fas fa-image"></i>
            <span>Imágenes</span>
        </p>
        <p>Tamaño total de imágenes: {{ imagesSize }} MB</p>
        <table id="heading-multimedia-images-table" class="mt-3">
            <thead>
                <tr>
                    <th>Miniatura</th>
                    <th>Ancho / Alto</th>
                    <th>Alineación</th>
                    <th>Texto alternativo</th>
                    <th>Fuente / Referencia complementaria</th>
                    <!-- <th>Audio</th> -->
                    <th>Referencia (Copiar y pegar en el texto para insertar)</th>
                    <th>Eliminar</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let image of images">
                    <td>
                        <a href="{{ image.url }}" target="_blank" title="Clic para ver en nueva pestaña">
                            <img width="100" height="100" src="{{ image.url }}" alt="{{ image.file }}">
                        </a>
                    </td>
                    <td>
                        <div>
                            <label>
                                <span>Ancho:</span>
                                <input type="number" size="5" [(ngModel)]="image.width" (ngModelChange)="changeWidthHeight(image, 'width')">
                            </label>
                            <label>
                                <span>Alto:</span>
                                <input type="number" size="5" [(ngModel)]="image.height" (ngModelChange)="changeWidthHeight(image, 'height')">
                            </label>
                        </div>
                        <div>
                            <a href="#" title="Mantener proporciones" (click)="changeProp(image)">
                                <span *ngIf="image.prop">
                                    <i class="fa fa-lock"></i>
                                </span>
                                <span *ngIf="!image.prop">
                                    <i class="fa fa-lock-open"></i>
                                </span>
                            </a>
                        </div>
                    </td>
                    <td>
                        <select [(ngModel)]="image.align" (ngModelChange)="updateMultimediaRef(image)">
                            <option value="down">Abajo</option>
                            <option value="left">Izquierda</option>
                            <option value="right">Derecha</option>
                        </select>
                    </td>
                    <td>
                        <input type="text" [(ngModel)]="image.alt">
                        <div class="mt-2">
                            <a href="#" title="Guardar texto alternativo" (click)="editMultimedia(image, 'alt')" *ngIf="!image.altSaved"> 
                                <i class="far fa-save"></i>
                                <span>Guardar</span>
                            </a>
                            <span *ngIf="image.altSaved">
                                <i class="far fa-thumbs-up"></i>
                                <span>¡Guardado!</span>
                            </span>
                        </div>
                    </td>
                    <td>
                        <input type="text" [(ngModel)]="image.source">
                        <div class="mt-2">
                            <a href="#" title="Guardar texto alternativo" (click)="editMultimedia(image, 'source')" *ngIf="!image.sourceSaved"> 
                                <i class="far fa-save"></i>
                                <span>Guardar</span>
                            </a>
                            <span *ngIf="image.sourceSaved">
                                <i class="far fa-thumbs-up"></i>
                                <span>¡Guardado!</span>
                            </span>
                        </div>
                    </td>
                    <!--
                    <td>
                        <div id="image-no-audio" *ngIf="image.audio == ''">
                            <p>Esta imagen no tiene audio.</p>
                        </div>
                        <div id="image-audio" *ngIf="image.audio != ''">
                            <audio src="{{ image.audio }}" controls>
                            </audio>
                        </div>
                        <div id="multimedia-audio-new">
                            <!-- <span>Puede subir un archivo existente o generarlo con nuestra herramienta.</span> <--
                            <label for="multimedia-audio-upload">
                                <span class="fw-bold">Subir nuevo audio: </span>
                                <input id="multimedia-audio-upload" type="file" name="audio[]" accept="audio/*" (change)="audioUpload(image.id, $event)">
                            </label>
                            <span class="fw-bold ms-3 me-3">/</span>
                            <button class="btn btn-primary" routerLink="/generate-audio/{{ courseID }}" routerLinkActive="active">
                                <i class="fa fa-play-circle"></i>
                                <span>Generar audio</span>
                            </button>
                        </div>
                    </td>
                    -->
                    <td>
                        <input type="text" disabled [value]="image.ref">
                        <div class="mt-2" *ngIf="clipboard">
                        <!-- <div class="mt-2"> -->
                            <a href="#" title="Copiar referencia" (click)="copyMultimediaRef(image)" *ngIf="!image.refCopied">
                                <i class="far fa-copy"></i>
                                <span>Copiar</span>
                            </a>
                            <span *ngIf="image.refCopied">
                                <i class="far fa-thumbs-up"></i>
                                <span>¡Copiado!</span>
                            </span>
                        </div>
                    </td>
                    <td>
                        <a href="#" title="Eliminar elemento" class="text-danger" (click)="deleteMultimediaItem(image)">
                            <i class="fas fa-times"></i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    
    <div id="heading-multimedia-video" class="mt-3" *ngIf="!upload && videos.length > 0">
        <hr>
        <p class="fw-bold">
            <i class="fas fa-film"></i>
            <span>Vídeos</span>
        </p>
        <p>Tamaño total de vídeos: {{ videosSize }} MB</p>
        <table id="heading-multimedia-videos-table" class="mt-3">
            <thead>
                <tr>
                    <th>Miniatura</th>
                    <th>Ancho / Alto</th>
                    <th>Alineación</th>
                    <th>Texto alternativo</th>
                    <th>Fuente / Referencia complementaria</th>
                    <th>Subtítulos</th>
                    <th>Referencia (Copiar y pegar en el texto para insertar)</th>
                    <th>Eliminar</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let video of videos">
                    <td>
                        <div *ngIf="video.file">
                            <div *ngIf="!video.part">
                                <video width="400" height="400" [src]="video['file']" controls></video>
                                <div>
                                    <a href="#" title="Ver en nueva pestaña" (click)="open(video.file)">
                                        <i class="fas fa-eye"></i>
                                        <span>Ver en nueva pestaña</span>
                                    </a>
                                </div>
                            </div>
                            <div *ngIf="video.part">
                                <i class="fa fa-spinner fa-spin"></i>
                                <span>Descargando vídeo... Inténtelo de nuevo más tarde.</span>
                            </div>
                        </div>
                        <div *ngIf="video.url">
                            <iframe width="400" height="400" [src]="video['safeUrl']"></iframe>
                            <div>
                                <a href="#" title="Ver en nueva pestaña" (click)="open(video.url)">
                                    <i class="fas fa-eye"></i>
                                    <span>Ver en nueva pestaña</span>
                                </a>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div>
                            <label>
                                <span>Ancho:</span>
                                <input type="number" size="5" [(ngModel)]="video.width" (ngModelChange)="changeWidthHeight(video, 'width')">
                            </label>
                            <label>
                                <span>Alto:</span>
                                <input type="number" size="5" [(ngModel)]="video.height" (ngModelChange)="changeWidthHeight(video, 'height')">
                            </label>
                        </div>
                        <div>
                            <a href="#" title="Mantener proporciones" (click)="changeProp(video)">
                                <span *ngIf="video.prop">
                                    <i class="fa fa-lock"></i>
                                </span>
                                <span *ngIf="!video.prop">
                                    <i class="fa fa-lock-open"></i>
                                </span>
                            </a>
                        </div>
                    </td>
                    <td>
                        <select [(ngModel)]="video.align" (ngModelChange)="updateMultimediaRef(video)">
                            <option value="down">Abajo</option>
                            <option value="left">Izquierda</option>
                            <option value="right">Derecha</option>
                        </select>
                    </td>
                    <td>
                        <input type="text" [(ngModel)]="video.alt">
                        <div class="mt-2">
                            <a href="#" title="Guardar texto alternativo" (click)="editMultimedia(video, 'alt')" *ngIf="!video.altSaved">
                                <i class="far fa-save"></i>
                                <span>Guardar</span>
                            </a>
                            <span *ngIf="video.altSaved">
                                <i class="far fa-thumbs-up"></i>
                                <span>¡Guardado!</span>
                            </span>
                        </div>
                    </td>
                    <td>
                        <input type="text" [(ngModel)]="video.source">
                        <div class="mt-2">
                            <a href="#" title="Guardar texto alternativo" (click)="editMultimedia(video, 'source')" *ngIf="!video.sourceSaved">
                                <i class="far fa-save"></i>
                                <span>Guardar</span>
                            </a>
                            <span *ngIf="video.sourceSaved">
                                <i class="far fa-thumbs-up"></i>
                                <span>¡Guardado!</span>
                            </span>
                        </div>
                    </td>
                    <td>
                        <textarea cols="30" rows="10">
                            {{ video.subtitles }}
                        </textarea>
                        <input type="file" class="d-none" (change)="uploadSubtitles($event)" accept="text/plain">
                        <button class="btn btn-primary me-2" (click)="uploadSubtitlesClick($event)">
                            <i class="fa fa-upload"></i>
                            <span>Subir archivo</span>
                        </button>
                        <button class="btn btn-success me-2" (click)="saveSubtitles($event, video.id)">
                            <i class="fa fa-save"></i>
                            <span>Guardar</span>
                        </button>
                    </td>
                    <td>
                        <input type="text" disabled [value]="video.ref">
                        <div class="mt-2" *ngIf="clipboard">
                        <!-- <div class="mt-2"> -->
                            <a href="#" title="Copiar referencia" (click)="copyMultimediaRef(video)" *ngIf="!video.refCopied">
                                <i class="far fa-copy"></i>
                                <span>Copiar</span>
                            </a>
                            <span *ngIf="video.refCopied">
                                <i class="far fa-thumbs-up"></i>
                                <span>¡Copiado!</span>
                            </span>
                        </div>
                    </td>
                    <td>
                        <a href="#" title="Eliminar elemento" class="text-danger" (click)="deleteMultimediaItem(video)">
                            <i class="fas fa-times"></i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</div>